<template>
  <div class="pagebox">
    <button label="上一頁" :class="text?'text':''" @click="value=value-1" :disabled="value<=1"><div></div></button>
    <div class="page">{{value}}</div>
    <button label="下一頁" :class="text?'text':''" @click="value=value+1" :disabled="max?value>=max:false"><div></div></button>
  </div>
</template>

<script>
export default {
  props: ['max', 'text', 'defaultValue'],
  data () {
    return {
      value: 1
    }
  },
  watch: {
    defaultValue () {
      this.value = parseInt(this.defaultValue) || 1
    },
    value () {
      this.$emit('input', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  width: 40px;
  height: 40px;
  min-width: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background-color: transparent;
  &.text{
    width: 122px;
    &:nth-child(1):before {
      content: attr(label);
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0.1em;
      color: var(--color-pri);
    }
    &:nth-child(3)::after {
      content: attr(label);
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0.1em;
      color: var(--color-pri);
    }
  }
  &>div{
    background-color: var(--color-pri);
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-image: url(./svg/btn/page.svg);
    background-repeat: no-repeat;
    background-position: 8px;
  }
  &:nth-child(3)>div {
    transform: rotate(180deg);
  }
}
.page {
  width: 78px;
  font-weight: 400;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;
  color: #6D6D6D;
  text-align: center;
}
.pagebox {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
